import styles from './index.module.css'
import crumbsImg from '../../../../statics/detail_crumbs_icon.png'


function ImageOverview({data, imageUrl, setIsImageModalOpen, setShowImageUrl}) {
    const handleClickImg = () => {
        setIsImageModalOpen(true)
        setShowImageUrl(imageUrl)
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.header__crumbs}>
                    <span className={styles.header__crumbs__textDisabled}>{data?.tags?.[0] ?? '空'}</span>
                    <img src={crumbsImg} alt="icon" className={styles.header__crumbs__icon} />
                    <span className={styles.header__crumbs__textDisabled}>{data?.tags?.[1] ?? '空'}</span>
                    <img src={crumbsImg} alt="icon" className={styles.header__crumbs__icon} />
                    <span className={styles.header__crumbs__text}>{data.name}</span>
                </div>
            </div>

            <div className={styles.section}>
                <div className={styles.section__left}>
                    <div className={styles.section__left__minpic}>
                        <div className={styles.left__img__box}>
                            <img src={imageUrl} alt="img" className={styles.left__img} />
                        </div>
                    </div>
                    <div className={styles.section__left__maxpic}>
                        <img
                            src={imageUrl}
                            alt="img"
                            className={styles.left__img}
                            onClick={handleClickImg}
                        />
                    </div>
                </div>
                <div className={styles.section__right}>
                    <div className={styles.right__header}>{data.name}</div>
                    <div className={styles.right__section}>
                        <div className={styles.right__section__title}>
                            参考价
                        </div>
                        <div className={styles.right__section__text}>
                            { parseInt(data?.meta_data?.min_price ?? 0) === parseInt(data?.meta_data?.max_price ?? 0) ? parseInt(data?.meta_data?.min_price ?? 0) : parseInt(data?.meta_data?.min_price ?? 0) + '-' + parseInt(data?.meta_data?.max_price ?? 0) } 元/平
                        </div>
                    </div>
                    <div className={styles.right__section}>
                        <div className={styles.right__section__title}>
                            品牌
                        </div>
                        <div className={styles.right__section__text}>{data?.meta_data?.supplier_name ?? '空'}</div>
                    </div>
                    <div className={styles.right__section}>
                        <div className={styles.right__section__title}>
                            描述
                        </div>
                        <div className={styles.right__section__info}>
                            {data?.description ?? '空'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImageOverview